import React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helper";
import { selectPractice, setPracticeLocation } from "../../store/actions";

export default function SelectPracticeTable({ dispatch, aryData }) {
  const columns = [
    {
      field: "id",
      headerName: "Action",
      minWidth: 50,
      renderCell: (e) => (
        <button
          className="button"
          onClick={() => {
            dispatch(
              selectPractice(e.row.practice_id, e.row.practice_name, e.row),
            );
            dispatch(setPracticeLocation([]));
          }}
        >
          Select
        </button>
      ),
    },
    {
      field: "practice_id",
      headerName: "Practice ID",
      minWidth: 70,
    },
    {
      field: "practice_name",
      headerName: "Practice Name",
      minWidth: 170,
      flex: 1,
    },
  ];

  return (
    <Box sx={{ height: "auto", width: "auto" }}>
      <DataGrid
        rows={aryData}
        columns={columns}
        autoHeight
        pagination
        pageSize={10}
        density="compact"
        components={{
          Pagination: DataGridCustomPagination,
          Toolbar: GridToolbar,
        }}
      />
    </Box>
  );
}
